// extracted by mini-css-extract-plugin
export default {"imageWrapper":"iT-z","hovered":"jT-z","hoverImage":"kT-z","mainImage":"lT-z","imageNoBackground":"mT-z","fullSizeImage":"nT-z"};